export enum PaymentType {
  AdditionalUsers = 'AdditionalUsers',
  FirstSubscriptionActivated = 'FirstSubscriptionActivated',
  SharePoint = 'SharePoint',
  StorageChange = 'StorageChange',
  StorageAndTraffic = 'StorageAndTraffic',
  SubscriptionUpdated = 'SubscriptionUpdated',
  TeamDrive = 'TeamDrive'
}
